import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { useSearchStore } from "../..";
import useFlag from "../../hooks/useFlag";
import commonStyles from '../Common.module.css';
import styles from './SearchLine.module.css';

function SearchLine() {
    const searchStore = useSearchStore();
    const [query, setQuery] = useState("");
    const debouncedSetQuery = useDebouncedCallback(value => searchStore.setQuery(value), 500);
    const [isFirstRender, setIsFirstRenderFalse] = useFlag(true);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (query !== searchStore.query)
            setQuery(searchStore.query);

        if (searchStore.query || searchStore.isOpen)
            inputRef.current!.focus();
    }, [searchStore.query]);

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRenderFalse();
            return;
        }

        inputRef.current!.focus();
    }, [searchStore.type]);

    useEffect(() => {
        if (searchStore.isOpen)
            inputRef.current!.focus();
        else
            inputRef.current!.blur();
    }, [searchStore.isOpen]);

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRenderFalse();
            return;
        }

        if (searchStore.selectedItemIndex === null)
            inputRef.current!.focus();
        if (searchStore.selectedItemIndex === 0)
            inputRef.current!.blur();
    }, [searchStore.selectedItemIndex]);

    return (
        <div className={styles.container} onClick={() => searchStore.setIsOpen(true)}>
            <SearchIcon />
            <input
                placeholder="Search Recity..."
                value={query}
                onChange={e => {
                    setQuery(e.target.value);
                    debouncedSetQuery(e.target.value);
                }}
                ref={inputRef}
                onFocus={() => {
                    searchStore.setIsOpen(true);
                    searchStore.setSelectedItemIndex(null);
                }}
            />
            {query && (
                <CloseIcon className={commonStyles.clickableIcon} onClick={e => {
                    e.stopPropagation();
                    searchStore.setQuery("");
                }} />
            )}
        </div>
    );
}

export default observer(SearchLine);